module.exports = __webpack_public_path__ + "static/img/7.dcda5ab.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/18/zh/7.png
// module id = yYvn
// module chunks = 0